/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Edit_Is_DisabledInputs */

const en_forms_users_edit_is_disabled = /** @type {(inputs: Forms_Users_Edit_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const de_forms_users_edit_is_disabled = /** @type {(inputs: Forms_Users_Edit_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist deaktiviert`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Forms_Users_Edit_Is_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_edit_is_disabled = /** @type {((inputs?: Forms_Users_Edit_Is_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Edit_Is_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_edit_is_disabled(inputs)
	return de_forms_users_edit_is_disabled(inputs)
});